var _path, _path2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51758 16.865H14.3279V6.05457H3.51758V16.865ZM4.4994 15.8831H13.3462V7.03638H4.4994V15.8831Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97717 6.54545H6.95898V4.0909C6.95898 2.46673 5.63762 1.14545 4.01353 1.14545C2.38944 1.14545 1.06808 2.46673 1.06808 4.0909V5.08655H2.04989V4.0909C2.04989 3.00812 2.93075 2.12727 4.01353 2.12727C5.09631 2.12727 5.97717 3.00812 5.97717 4.0909V6.54545Z",
    fill: "#FCFCFC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 12,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51758 16.8649H14.328V1.14545H3.51758V16.8649Z",
    fill: "#FCFCFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95898 10.4873H10.8862V9.50543H6.95898V10.4873Z",
    fill: "#FCFCFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockOpen);
export default __webpack_public_path__ + "static/media/padlock-open.7e94b09fcb970db09969328da337e908.svg";
export { ForwardRef as ReactComponent };